import { render, staticRenderFns } from "./SimpleSelectDepot.vue?vue&type=template&id=483c10e8"
import script from "./SimpleSelectDepot.vue?vue&type=script&lang=js"
export * from "./SimpleSelectDepot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports